import { render, staticRenderFns } from "./FinalClaimPack.vue?vue&type=template&id=656fe467&scoped=true&"
import script from "./FinalClaimPack.vue?vue&type=script&lang=js&"
export * from "./FinalClaimPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656fe467",
  null
  
)

export default component.exports